
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Toaster } from "@/components/ui/toaster"

// Log the environment variables to debug
console.log("Environment variables:", {
  BASE_URL: import.meta.env.BASE_URL,
  MODE: import.meta.env.MODE,
});

createRoot(document.getElementById("root")!).render(
  <>
    <App />
    <Toaster />
  </>
);
